import { useEffect, useState } from "react";

import { Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageTitle from "components/elements/PageTitle";
import Panel from "components/elements/Panel";
import { useUserDataContext } from "context/UserDataContext";
import { useTranslation } from "react-i18next";
import { getLocalStorageBooleanValue } from "utils";

import InvoiceSetup from "./InvoiceSetup";
import ModalChangePassword from "./ModalChangePassword";
import ModalChangeUserEmail from "./ModalChangeUserEmail";
import ModalDeleteAccount from "./ModalDeleteAccount";
import SettingsItem from "./SettingsItem";

const SettingsPage = () => {
  const { t } = useTranslation();
  const [modalChangePasswordOpen, setModalChangePasswordOpen] = useState(false);
  const [invoiceSetupOpen, setInvoiceSetupOpen] = useState(false);
  const [modalDeleteAccountOpen, setModalDeleteAccountOpen] = useState(false);
  const [modalChangeUserEmailOpen, setModalChangeUserEmailOpen] = useState(false);
  const { mfaEnabled, refreshData } = useUserDataContext();

  const onModalChangePasswordOpen = () => setModalChangePasswordOpen(true);
  const onModalChangePasswordClose = () => setModalChangePasswordOpen(false);

  const onInvoiceSetupOpen = () => setInvoiceSetupOpen(true);
  const onInvoiceSetupClose = () => setInvoiceSetupOpen(false);

  const onModalDeleteAccountOpen = () => setModalDeleteAccountOpen(true);
  const onModalDeleteAccountClose = () => setModalDeleteAccountOpen(false);

  const onModalChangeUserEmailOpen = () => setModalChangeUserEmailOpen(true);
  const onModalChangeUserEmailClose = () => setModalChangeUserEmailOpen(false);

  const isNotificationsEnabled = getLocalStorageBooleanValue("featureNotificationsEnabled", false);

  useEffect(() => {
    refreshData?.();
  }, [mfaEnabled]);

  return (
    <Grid container justifyContent="center" spacing={8}>
      <PageTitle i18nKey="settingsPage.meta_title" />
      <Grid item sx={{ width: "100%", maxWidth: "md" }}>
        <Panel sx={{ p: 4, mb: 10 }}>
          <Typography variant="h5" component="h1" fontWeight={600} sx={{ pb: 3, color: "tertiary.main" }}>
            {t("settingsPage.title")}
          </Typography>
          <Stack spacing={2} divider={<Divider />}>
            <SettingsItem
              section={t("settingsPage.invoice")}
              value={t("settingsPage.invoiceDesc")}
              actionLabel={t("settingsPage.invoiceSetup")}
              action={onInvoiceSetupOpen}
            />
            {isNotificationsEnabled && <SettingsItem
              section={t("settingsPage.notifications.title")}
              value={t("settingsPage.notifications.description")}
              actionLabel={t("settingsPage.notifications.setup")}
              to={"/notifikace"}
            />}
            <SettingsItem
              section={t("settingsPage.emailPreferences.title")}
              value={t("settingsPage.emailPreferences.description")}
              actionLabel={t("edit")}
              to={"/e-mailove-preference"}
            />
            <SettingsItem
              section={t("settingsPage.mfa")}
              value={mfaEnabled ? t("on") : t("off")}
              description={t("settingsPage.mfaDescription")}
              actionLabel={mfaEnabled ? t("settingsPage.mfaDisable") : t("settingsPage.mfaSetup")}
              to={"/dvoufaktorove-overeni"}
            />
            <SettingsItem
              section={t("settingsPage.password")}
              value={t("settingsPage.passwordPlaceholder")}
              actionLabel={t("settingsPage.changePassword")}
              action={onModalChangePasswordOpen}
            />
            <SettingsItem
              section={t("settingsPage.changeUserEmail.title")}
              value={t("settingsPage.changeUserEmail.description")}
              actionLabel={t("settingsPage.changeUserEmail.cta")}
              action={onModalChangeUserEmailOpen}
            />
            <SettingsItem
              section={t("settingsPage.language")}
              value={t("language.cs")}
              actionLabel={t("settingsPage.comingSoon")}
            />
            <SettingsItem
              section={t("settingsPage.deleteAccount")}
              value={t("settingsPage.deleteAccountDesc")}
              actionLabel={t("delete")}
              action={onModalDeleteAccountOpen}
            />
          </Stack>
        </Panel>
        <ModalChangePassword open={modalChangePasswordOpen} onClose={onModalChangePasswordClose} />
        {invoiceSetupOpen && <InvoiceSetup onClose={onInvoiceSetupClose} />}
        {modalDeleteAccountOpen && <ModalDeleteAccount onClose={onModalDeleteAccountClose} />}
        {modalChangeUserEmailOpen && <ModalChangeUserEmail onClose={onModalChangeUserEmailClose} />}
      </Grid>
    </Grid>
  );
};
export default SettingsPage;
